// extracted by mini-css-extract-plugin
export default {"container":"K2-z","list":"L2-z"};